/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HomeBannerEligible } from '../models/HomeBannerEligible';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HomeBannersService {

    /**
     * List Eligible Home Banners
     * Every banner live for this viewer right now, in no particular order.
     *
     * The frontend picks the one to show (the shortest) and handles dismissals.
     * @param timezone The viewer's IANA timezone, from Intl.DateTimeFormat().resolvedOptions().timeZone.
     * @returns HomeBannerEligible Successful Response
     * @throws ApiError
     */
    public static listEligibleHomeBannersApiV1HomeBannersEligibleGet(
        timezone: string,
    ): CancelablePromise<Array<HomeBannerEligible>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/home/banners/eligible',
            query: {
                'timezone': timezone,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Home Banner Image
     * A banner's image. Only images a banner currently uses are served.
     * @param imageId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getHomeBannerImageApiV1HomeBannersImagesImageIdGet(
        imageId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/home/banners/images/{image_id}',
            path: {
                'image_id': imageId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
